<template>
    <div class="bet-numbers-history">
        <button
            class="btn bet-numbers-history__button"
            @click="handleActiveChosenNumber"
        >
            <div
                class="bet-numbers-history__button--icon"
                :class="{
                    'bet-numbers-history__button--icon--active': isActiveChosenNumber,
                }"
            ></div>
            <div class="bet-numbers-history__button--title">
                Số đã cược
            </div>
        </button>
        <div
            v-show="isActiveChosenNumber && inputValue.length === 0"
            class="bet-numbers-history__message"
        >
            <span>* Bạn chưa từng cược</span>
        </div>
        <div
            v-show="isActiveChosenNumber && inputValue.length !== 0"
            class="bet-numbers-history__body"
        >
            <div class="bet-numbers-history__body--list">
                <button
                    v-for="(number, index) in listShortNumber"
                    :key="index"
                    class="bet-numbers-history__body--list-button"
                    :class="{
                        'bet-numbers-history__body--list-button-active': isActiveNumbers.includes(
                            parseInt(number),
                        ),
                    }"
                    @click="clickOnNumber(parseInt(number))"
                >
                    {{ number }}
                </button>
            </div>
            <div
                class="bet-numbers-history__body--footer"
                v-show="listAllNumber.length > 9"
            >
                <Button
                    value="Tất cả"
                    type="submit"
                    @click="showAllHistoryNumbers()"
                    theme="dark"
                    variant="secondary"
                    class="classes bet-numbers-history__body--footer-button"
                />
            </div>
        </div>
        <div :class="['bet-numbers-history__modal', generateMocalClass()]">
            <button
                v-for="(number, index) in listAllNumber"
                :key="index"
                :class="[
                    {
                        'bet-numbers-history__popup--all-number--list-button-active': isActiveNumbers.includes(
                            parseInt(number),
                        ),
                    },
                    'bet-numbers-history__body--list-button',
                ]"
            >
                {{ number }}
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Button from '../Button/Button';

export default Vue.extend({
    name: 'BetNumber',
    data() {
        return {
            isActiveChosenNumber: false,
            listShortNumber: [],
            listAllNumber: [],
            isActiveNumbers: [],
        };
    },
    props: {
        maxNumber: {
            type: Number,
            required: false,
            default: 4,
        },
        lengthNumber: {
            type: Number,
            required: false,
            default: 2,
        },
        inputValue: {
            type: Array,
        },
        inputSelectedValue: {
            type: Array,
        },
        modalId: {
            type: String,
            required: true,
            default: 'number-modal',
        },
    },
    components: {
        Button,
    },
    watch: {
        '$store.state.betModule.betData.currentGame.code': function() {
            this.isActiveChosenNumber = false;
        },
    },
    methods: {
        handleActiveChosenNumber() {
            this.isActiveChosenNumber = !this.isActiveChosenNumber;
            if (this.isActiveChosenNumber) {
                this.$emit('onShow');
            }
        },
        clickOnNumber(numberInt) {
            if (this.isActiveNumbers.includes(numberInt)) {
                this.isActiveNumbers.splice(
                    this.isActiveNumbers.indexOf(numberInt),
                    1,
                );
            } else {
                if (this.isActiveNumbers.length < this.maxNumber) {
                    this.isActiveNumbers.push(numberInt);
                } else {
                    this.onErrorChecked();
                }
            }
            this.$emit('change', this.isActiveNumbers);
        },
        onErrorChecked: function() {
            this.$swal.fire({
                title:
                    '<div class="popup__icon popup__icon--limit-number"></div>',
                html: `<b>Bạn chỉ chọn tối đa ${this.maxNumber} số</b>`,
                customClass: {
                    popup: 'swal2-popup-warning-custom',
                },
                showCloseButton: true,
            });
        },
        showAllHistoryNumbers() {
            this.$swal.fire({
                title: 'SỐ BẠN ĐÃ TỪNG CƯỢC',
                html: this.getAllHistoryNumber(),
                customClass: {
                    popup:
                        'swal2-popup-html-custom bet-numbers-history__popup--all-number',
                },
                reverseButtons: true,
                showCloseButton: true,
                width: '50em',
            });
        },
        getAllHistoryNumber() {
            return document.getElementsByClassName(this.generateMocalClass())[0]
                .innerHTML;
        },
        generateMocalClass() {
            return 'bet-numbers-history__modal--' + this.modalId;
        },
    },
    beforeUpdate() {
        this.listAllNumber =
            this.inputValue && this.inputValue.length > 0
                ? this.inputValue
                      .map(numberInteger => {
                          let numberString = numberInteger + '';
                          while (numberString.length < this.lengthNumber)
                              numberString = '0' + numberString;
                          return numberString;
                      })
                      .sort()
                : [];

        this.listShortNumber = this.listAllNumber.slice(0, 9).sort();
        this.isActiveNumbers = this.inputSelectedValue;
    },
});
</script>

<style scoped lang="scss">
@import 'BetNumber';
</style>
